<template>
  <div class="settle-accounts-detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="baseFormRules"
            labelWidth="160px"
            @changeCompanyHandler="changeCompanyHandler"
            @changeDepartmentHandler="changeDepartmentHandler"
            @changeCurrencyHandler="changeCurrencyHandler"
            @changeSettlementDateHandler="changeSettlementDateHandler"
          ></SiruiSearch>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算行
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsRow
            ref="linesRef"
            @selectionRowHandler="selectionRowHandler"
            @closeEditTableHandler="closeRowEditTableHandler"
            @deleteTableHandler="deleteTableRowHandler"
            :baseFormData="baseFormData"
            :productList="productList"
            :isCreate="isCreate"
            :currentDetailData="currentDetailData"
            :settleAccountsDetailMap="settleAccountsDetailMap"
            :linesData="detailData.lines ? detailData.lines : []"
            @importData="importDataHandler"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3" v-if="currentSettleAccountRowData">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            结算明细
          </div>
        </template>
        <div class="collapse-content">
          <SettleAccountsInfo
            ref="lineDetails"
            :isCreate="isCreate"
            @closeEditTableHandler="closeDetailEditTableHandler"
            :tableDataList="currentSettleAccountDetailList"
            @deleteTableHandler="deleteTableDetailHandler"
            :baseFormData="baseFormData"
            @importData="importDataHandler"
            @selectHandler="selectHandler"
            @saveDeleteLineDetailIds="saveDeleteLineDetailIds"
            @_formatSettleAccountDto="_formatSettleAccountDto"
            :lineDetailsList="lineDetailsList"
            :currentSettleAccountRowData="currentSettleAccountRowData"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="7">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            订单执行情况
          </div>
        </template>
        <div class="collapse-content">
          <!-- <div>
            <el-button type="primary" @click="importDetailsHandler()"> 引入执行明细 </el-button>
            <el-button type="danger" @click="_deleteHandler()"> 删除 </el-button>
          </div> -->
          <CommonTransportation
            v-if="serviceTypeShow == '0' && commonTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :preSettlements="commonTransportationDataList"
            :showTitle="false"
          />
          <CommonTransportation
            v-if="serviceTypeShow == '1' && truckTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :preSettlements="truckTransportationDataList"
            marked="集卡运输"
            :showTitle="false"
          />
          <!-- <TruckTransportation
            v-if="serviceTypeShow == '1' && truckTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :preSettlements="truckTransportationDataList"
          /> -->
          <PublickTransport
            v-if="serviceTypeShow == '2' && highWayTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :showTitle="false"
            :preSettlements="highWayTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '3' && consultTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="咨询服务"
            :showTitle="false"
            :preSettlements="consultTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '4' && storageTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="仓储服务"
            :showTitle="false"
            :preSettlements="storageTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '5' && superviseTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="监管服务"
            :showTitle="false"
            :preSettlements="superviseTransportationDataList"
          />
          <PublickTransport
            v-if="serviceTypeShow == '7' && railWayLoadTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            transportType="铁路装卸服务"
            :showTitle="false"
            :preSettlements="railWayLoadTransportationDataList"
          />
          <RailwayTransportation
            v-if="serviceTypeShow == '6' && railWayTransportationDataList.length > 0"
            ref="instructionExecutionDetails"
            :showTitle="false"
            :preSettlements="railWayTransportationDataList"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="4" v-if="billingInfoData.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            开票信息
          </div>
        </template>
        <div class="collapse-content">
          <BillingInfo :billingInfoData="billingInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5" v-if="payeeInfoData.length > 0">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            收款信息
          </div>
        </template>
        <div class="collapse-content">
          <PayeeInfo :payeeInfoData="payeeInfoData" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="detailData.attachments"
            :isShowDownBtn="!isCreate"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 按钮组 -->
    <div class="btn-group">
      <el-button v-if="isCreate" type="primary" key="777" @click="_saveHandler()"> 保存 </el-button>
      <el-button v-if="isCreate" type="primary" key="888" @click="_saveHandler(1)">
        提交审批
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['01', '03', '05'].includes(this.statementStatus) &&
          !isCreate
        "
        type="primary"
        key="999"
        @click="isCreate = true"
      >
        编辑
      </el-button>
      <el-button
        v-if="
          ['detail'].includes(this.currentStatus) &&
          ['06'].includes(this.statementStatus) &&
          billingInfoData.length < 1 &&
          !isCreate
        "
        type="primary"
        key="666"
        @click="isCreate = true"
      >
        调整
      </el-button>
      <el-button
        type="primary"
        v-for="(item, index) of btnList"
        :key="index"
        @click="btnClickHandler(item.type)"
        >{{ item.title }}</el-button
      >
    </div>
    <Print ref="easyPrint">
      <print-demo :content="content"></print-demo>
    </Print>
    <PrintDialog ref="PrintDialog" @printHandler="DetailprintHandler"></PrintDialog>
  </div>
</template>

<script>
  // import BaseInfo from './components/BaseInfo/index.vue';
  import SettleAccountsRow from './components/SettleAccountsRow/index.vue';
  import SettleAccountsInfo from './components/SettleAccountsInfo/index.vue';
  import BillingInfo from './components/BillingInfo/index.vue';
  import PayeeInfo from './components/PayeeInfo/index.vue';
  // import FileTable from './components/FileTable/index.vue';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import baseInfoMixin from './components/BaseInfo/index.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import Print from '@/components/Print';
  import printDemo from '@/components/Print/printDemo';
  import PrintDialog from '../../../../components/PrintDialog.vue';
  import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import { formatDate } from '@/utils';
  import CommonTransportation from '../ExpenseListDetail/components/CommonTransportation/index.vue';
  import PublickTransport from '../ExpenseListDetail/components/PublickTransport/index.vue';
  import RailwayTransportation from '../ExpenseListDetail/components/RailwayTransportation/index.vue';
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import XEUtils from 'xe-utils';
  import { round as _round } from 'lodash'

  export default {
    name: 'multimodalTransportReceivablesDetail',
    mixins: [baseInfoMixin],
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6', '7'],
        baseFormData: {},
        content: '',
        currentSettleAccountRowData: null, // 当前选中的行数据
        settleAccountsRowList: [], // 全部的行数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,值为结算明细数组
        currentSettleAccountDetailList: [], //明细表数据
        currentStatus: '',
        currentDetailData: {}, // 当前结算明细数据
        statementStatus: '', // 结算单状态
        statementIssueStatus: '', // 开票状态
        detailData: {}, // 根据id查询出来的数据
        billingInfoData: [], //根据结算单号查询出来的开票信息
        payeeInfoData: [], //根据结算单号查询出来的收款信息

        serviceTypeShow: '',
        commonTransportationDataList: [], //普通公路
        truckTransportationDataList: [], //集卡运输
        highWayTransportationDataList: [], //公路装卸
        consultTransportationDataList: [], //咨询服务
        storageTransportationDataList: [], //仓储服务
        superviseTransportationDataList: [], //监管服务
        railWayLoadTransportationDataList: [], //铁路装卸服务
        railWayTransportationDataList: [], //铁路运输服务
        noLineDetails: false, //判断每个结算行至少要对应一个结算明细
        settlementIndex: '', //具体是哪个结算行没有结算明细
        deleteLineDetailIds: [],
        lineDetailsList: [], //所有的明细行数据
      };
    },
    methods: {
      saveDeleteLineDetailIds(val) {
        this.deleteLineDetailIds = val;
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        console.log(rowData, 'rowData');
        this.currentSettleAccountRowData = rowData;
        this.serviceTypeShow = '';
        //涉及到详情编辑的时候回显明细行
        if (rowData) {
          const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(rowData._XID);
          this.currentSettleAccountDetailList = currentSettleAccountDetailList
            ? currentSettleAccountDetailList
            : [];
          this.$refs?.lineDetails?.clearSelection();
        }
      },
      // 关闭行编辑的时候
      closeRowEditTableHandler(tableData, isFetchData = false) {
        if (!tableData.length) return;
        this.settleAccountsRowList = tableData;
        // 计算原币结算金额和本币计算金额
        this._computeRowTableTotalAmount(tableData);
        if (isFetchData) {
          // 把当前表格里面的lineDetails设置到map中
          for (const item of tableData) {
            // 找到当前项的lineDetails
            let currentItem = this.detailData.lines.find((it) => it.id == item.id);
            const lineDetails = currentItem?.lineDetails ? currentItem?.lineDetails : [];
            if (!this.settleAccountsDetailMap.get(item._XID)) {
              this.settleAccountsDetailMap.set(item._XID, lineDetails);
            }
          }
        }
      },
      // 关闭明细表的时候
      closeDetailEditTableHandler(tableData) {
        console.log(tableData, '监听明细中');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, tableData);
        console.log(this.settleAccountsDetailMap, '明细中', this.currentSettleAccountRowData._XID);
        this.currentSettleAccountDetailList = tableData;
        this._computedDetailTableTotalAmount(tableData);
      },
      // 删除结算行
      deleteTableRowHandler(rowIdList, tableData) {
        console.log(rowIdList, '删除行', this.settleAccountsRowList);
        this.settleAccountsRowList = this.settleAccountsRowList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        // 计算金额
        this._computeRowTableTotalAmount(tableData);
      },
      // 导入明细表数据
      importDataHandler(importData) {
        console.log(importData, '导入明细表');
        const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
        // this.importData = data;
        const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        let detailData = importData.map((item) => {
          return {
            ...item,
            currencyCode,
            currencyName,
            exchangeRate,
            businessDocNo: item.businessDocCode,
            settlementQuantity: item.statementQuantity,
            taxRate: item.taxRate ? item.taxRate : 0,
            originalAmountWithoutTax: (
              item.originalAmount /
              (1 + +(item.taxRate ? item.taxRate : 0))
            ).toFixed(2),
            originalTaxAmount: (
              item.originalAmount -
              item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))
            ).toFixed(2),
            domesticAmountWithoutTax: (
              (item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))) *
              item.exchangeRate
            ).toFixed(2),
            domesticTaxAmount: (
              item.domesticAmount -
              (item.originalAmount / (1 + +(item.taxRate ? item.taxRate : 0))) * item.exchangeRate
            ).toFixed(2),
          };
        });

        console.log(detailData, 'detailData');
        let lines = this._formatSettleAccountDto();
        let newList = [];
        // if (currentSettleAccountDetailList && currentSettleAccountDetailList?.length) {
        //   let ids = currentSettleAccountDetailList.map((item) => item.id);
        //   newList = detailData.filter((item) => !ids.includes(item.id));
        // } else {
        //   newList = detailData;
        // }
        if (lines && lines.length) {
          if (this.lineDetailsList && this.lineDetailsList?.length) {
            let ids = this.lineDetailsList.map((item) => item.id);
            newList = detailData.filter((item) => !ids.includes(item.id));
          } else {
            newList = detailData;
          }
          this.currentSettleAccountDetailList = currentSettleAccountDetailList
            ? currentSettleAccountDetailList.concat(newList)
            : [].concat(newList);
          this.settleAccountsDetailMap.set(
            this.currentSettleAccountRowData._XID,
            this.currentSettleAccountDetailList
          );
          this.baseFormData.orderCode = this.baseFormData.orderCode || newList[0]?.orderCode;
          // 处理下反填到数据结算表中
          this._computedDetailTableTotalAmount(this.currentSettleAccountDetailList);
          // 处理好反填到表单上
          this._computeRowTableTotalAmount(this.settleAccountsRowList);
        }
      },
      // 删除明细行
      deleteTableDetailHandler(rowIdList) {
        console.log(rowIdList, '删除明细', this.settleAccountsDetailMap);
        // 获取当当前数组项目
        const detailListItem = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        console.log(detailListItem, '删除前');
        // 删除子项
        const newData = detailListItem.filter((item) => !rowIdList.includes(item.id));
        this.currentSettleAccountDetailList = this.currentSettleAccountDetailList.filter(
          (item) => !rowIdList.includes(item.id)
        );
        console.log(newData, '???删除后');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, newData);
        // 处理下反填到数据结算表中
        this._computedDetailTableTotalAmount(newData);
      },
      selectHandler(val) {
        let serviceType = val[0].serviceType;
        let expenseNo = val[0].expenseNo;
        console.log(val[0].serviceType, '选择的明细行-----val[0].serviceType');
        console.log(val[0].expenseNo, '选择的明细行------val[0].expenseNo');
        if (['0', '1'].includes(serviceType)) {
          this._importOrdinaryTruckHandler(serviceType, expenseNo);
        } else {
          this._importPublickTransportHandler(serviceType, expenseNo);
        }
      },
      async _importOrdinaryTruckHandler(serviceType, expenseNo) {
        let postData = { expenseNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.ORDINARY_TRUCK_QUERY_DETAIL_API,
          postData
        );
        console.log(data, '执行明细');
        if (data.code === 0) {
          if (serviceType == '0') {
            this.serviceTypeShow = serviceType;
            console.log(data.data, 'data.data');
            this.commonTransportationDataList = data.data;
          }
          if (serviceType == '1') {
            this.serviceTypeShow = serviceType;
            console.log(data.data, 'data.data');
            this.truckTransportationDataList = data.data;
          }
        } else {
          this.$message.error('获取失败');
        }
      },
      async _importPublickTransportHandler(serviceType, expenseNo) {
        let postData = { expenseNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.PUBLIC_TRANSPORT_QUERY_DETAIL_API,
          postData
        );
        console.log(data, '执行明细', serviceType);

        if (data.code === 0) {
          let publicList = [];
          if (data.data.length) {
            let {
              instructCode,
              purchaseOrgName,
              serviceProviderName,
              instructStatus,
              instructIssueDate,
              instructUpdateDate,
              businessComplatedDate,
              instructStatusName,
            } = data.data[0];

            publicList.push({
              instructCode,
              purchaseOrgName,
              serviceProviderName,
              instructStatus,
              instructIssueDate,
              instructUpdateDate,
              businessComplatedDate,
              instructStatusName,
            });
          }
          console.log(serviceType);
          if (serviceType == '2') {
            this.serviceTypeShow = serviceType;
            console.log(publicList, 'publicList');
            this.highWayTransportationDataList = publicList;
          }
          if (serviceType == '3') {
            this.serviceTypeShow = serviceType;
            this.consultTransportationDataList = publicList;
          }
          if (serviceType == '4') {
            this.serviceTypeShow = serviceType;
            this.storageTransportationDataList = publicList;
          }
          if (serviceType == '5') {
            this.serviceTypeShow = serviceType;
            this.superviseTransportationDataList = publicList;
          }
          if (serviceType == '6') {
            this.serviceTypeShow = serviceType;
            console.log(data.data[0], 'data.data[0].truckContainer');
            this.railWayTransportationDataList = data.data.length
              ? JSON.parse(data.data[0].truckContainer)
              : [];
          }
          if (serviceType == '7') {
            this.serviceTypeShow = serviceType;
            this.railWayLoadTransportationDataList = publicList;
          }
        } else {
          this.$message.error('获取失败');
        }
      },
      // 点击按钮组
      btnClickHandler(type) {
        if (type === 'save') {
          this._saveHandler();
        } else if (type === 'edit') {
          this.isCreate = true;
        } else if (type === 'approval') {
          this._saveHandler(1);
        } else if (type === 'billingApplication') {
          this._billingApplicationHandler();
        } else if (type === 'settlementLock') {
          this.lockHandler();
        } else if (type === 'resize') {
          this.isCreate = true;
        } else if (type === 'cancel') {
          this.withdrawHandler();
        } else if (type === 'close') {
          this.closeHandler();
        } else if (type === 'print') {
          this.printBtnClickHandler();
        }
        console.log(type, '点击按钮');
      },
      //打印
      printBtnClickHandler() {
        this.$refs.PrintDialog.openDialog();
        // this.loading.startLoading();
        // const params = {
        //   id: +this.$route.query?.id,
        //   downloadOrPrint: 'print',
        // };
        // this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
        //   if (res.data.code === 0) {
        //     this.loading.endLoading();
        //     if (res.data.data.pdf) {
        //       // window.location.href = res.data.data.pdf;
        //       window.open(res.data.data.pdf, '_blank');
        //     } else if (res.data.data.excel) {
        //       this.content = res.data.data.excel || '';
        //       setTimeout(() => {
        //         this.$refs.easyPrint.print();
        //       }, 500);
        //     }
        //   } else {
        //     this.loading.endLoading();
        //     this.$alert(res.data.msg);
        //   }
        // });
        // console.log('打印');
      },
      DetailprintHandler(val) {
        console.log(val);
        this.loading.startLoading();
        const params = {
          id: +this.$route.query?.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            this.loading.endLoading();
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          }
        });
      },
      //撤回
      async withdrawHandler() {
        this.$confirm('确定要撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_WITHDRAW_API, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('撤回成功');
              this.$router.go(-1);
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch(() => {});
      },
      //锁定
      async lockHandler() {
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_LOCK, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('锁定成功');
              this.$router.go(-1);
            } else {
              this.$message.error(data.msg);
            }
          })
          .catch(() => {});
      },
      //关闭
      async closeHandler() {
        this.$confirm('确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_CLOSE, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('关闭成功');
              this.$router.go(-1);
            } else {
              this.$message.error('关闭失败');
            }
          })
          .catch(() => {});
      },
      //开票申请
      async _billingApplicationHandler() {
        let postData = [this.$route.query?.id];
        // let postData = [28];
        const { data } = await this.$axios.post(
          `${RECEIVABLES_TRADE.RECEIVABLE_BILLINGAPPLICATION_API}?businessGroup=${this.userInfo.businessGroup}`,
          postData
        );
        if (data.code == 0) {
          let path = {
            path: '/saleInvoice/add',
            name: 'saleInvoiceAdd',
            meta: {
              keepAlive: true,
              title: '创建销售开票',
            },
            query: { isEdit: 'Y', source: 'receive' },
            params: data.data,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          if (data.msg) {
            return this.$message.error(data.msg);
          }
          this.$message('开票申请失败');
        }
      },
      // 保存接口 type 保存类型: 0-保存, 1-提交
      _saveHandler(type = 0) {
        console.log(this._formatSettleAccountDto(), '表格提交数据', this.settleAccountsDetailMap);
        console.log(this.$refs.linesRef.deleteLineIds, 'deleteLineIds');
        // 1.获取到基本信息数据
        this.$refs.baseInfoFormRef.validate(async (valid, baseInfoData) => {
          this.noLineDetails = false; //判断每个结算行至少要对应一个结算明细
          this.settlementIndex = '';
          if (!valid) {
            this.$message.error('请检查填写信息');
            return;
          }
          let checkLinesRefStatus = await this.$refs?.linesRef?.validAllEvent();
          if (checkLinesRefStatus) {
            return;
          }
          let checkLineDetailsStatus = await this.$refs?.lineDetails?.validAllEvent();
          if (checkLineDetailsStatus) {
            return;
          }
          // 判断原币结算总金额（含税）是否为负数
          if (baseInfoData.originalTotalAmount < 0) {
            this.$message.error('原币结算总金额（含税）不能为负');
            return;
          }
          //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
          // if (this.checkFalse()) {
          //   this.$message.error('结算行中原币结算单价（含税）和结算数量为必填项');
          //   return;
          // }
          if (this._formatSettleAccountDto().length < 1) {
            this.$message.error('结算行不能为空！');
            return;
          }
          //判断每个结算行至少要对应一个结算明细
          if (this.noLineDetails) {
            this.$message.error(`请填写第${this.settlementIndex}行结算行的结算明细`);
            return;
          }

          this.loading.startLoading();
          // 上传文件表格
          const fileTable = this.$refs.fileTableRef.getTableData();
          //删除的行ids
          const deleteLineIds = this.$refs?.linesRef.deleteLineIds
            ? this.$refs?.linesRef.deleteLineIds
            : [];
          //删除的明细表ids
          let deleteLineDetailIds =
            this.$refs?.lineDetails?.deleteLineDetailIds.length > 0
              ? this.$refs?.lineDetails?.deleteLineDetailIds
              : this.deleteLineDetailIds;
          let postData = {
            ...baseInfoData,
            signetType: baseInfoData.signetType.length ? baseInfoData.signetType.join(',') : null,
            type,
            oaId: JSON.parse(localStorage.getItem('userInfo')).userInfo.oaId,
            companyName: JSON.parse(localStorage.getItem('userInfo')).userInfo.companyName,
            businessGroup: JSON.parse(localStorage.getItem('userInfo')).userInfo.businessGroup,
            printFlag: baseInfoData.printFlag && baseInfoData.printFlag == '1' ? 1 : 0,
            lines: this._formatSettleAccountDto(),
            attachments: fileTable,
            receivableAccountPeriod: XEUtils.toDateString(
              baseInfoData.receivableAccountPeriod,
              'yyyy-MM'
            ),
            deleteLineIds,
            deleteLineDetailIds,
          };
          if (['edit', 'detail'].includes(this.$route.query?.status)) {
            postData.id = this.$route.query?.id;
          }
          const { data } = await this.$axios.post(
            RECEIVABLES_TRADE.CREATE_OR_EDIT_TRADE_RECEIVABLES_API,
            postData
          );

          console.log(data, '保存结果');
          if (data.code === 0) {
            this.loading.endLoading();
            this.$message.success(data.msg);
            // this.$router.go(-1);
            this.closeTab();
          } else {
            this.loading.endLoading();
            this.$message.error(data.msg);
          }
        });
      },
      closeTab() {
        // 关闭当前tab导航
        this.$store.dispatch('tagsView/delView', {
          path: '/receivablesAndPayables/multimodalTransportReceivablesDetail',
          name: 'multimodalTransportReceivablesDetail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push({ path: '/receivablesAndPayables/receivablesList' });
      },
      //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
      checkFalse() {
        let lines = this._formatSettleAccountDto();
        let checkStatus = false;
        if (lines && lines.length) {
          for (let index = 0; index < lines.length; index++) {
            const item = lines[index];
            console.log(item);
            if (!item.lineDetails?.length && !item.originalPrice && !item.settlementQuantity) {
              checkStatus = true;
              break;
            }
          }
        }
        if (checkStatus) {
          return true;
        }
      },
      // 组装结算行结算明细数据给后端
      _formatSettleAccountDto() {
        const settleAccountList = [];
        this.lineDetailsList = [];
        this.settleAccountsRowList.map((item, index) => {
          const lineDetails = this.settleAccountsDetailMap.get(item._XID);
          if (!(lineDetails && lineDetails.length)) {
            this.noLineDetails = true; //判断每个结算行至少要对应一个结算明细
            this.settlementIndex = +index + 1;
          }
          this.lineDetailsList = this.lineDetailsList.concat(lineDetails || []);
          settleAccountList.push({
            ...item,
            additional: item.additional ? 1 : 2,
            lineDetails: lineDetails ? lineDetails : [],
          });
        });
        return settleAccountList;
      },
      // 计算原币金额和本币金额到表单中
      _computeRowTableTotalAmount(tableData) {
        let originalTotalAmount = 0;
        let domesticTotalAmount = 0;
        let originalTotalAmountWithoutTax = 0;
        let originalTotalTaxAmount = 0;
        let domesticTotalAmountWithoutTax = 0;
        let domesticTotalTaxAmount = 0;
        for (const item of tableData) {
          originalTotalAmount += +item['originalAmount'];
          domesticTotalAmount += +item['domesticAmount'];

          originalTotalAmountWithoutTax += +item['originalAmountWithoutTax'];
          originalTotalTaxAmount += +item['originalTaxAmount'];
          domesticTotalAmountWithoutTax += +item['domesticAmountWithoutTax'];
          domesticTotalTaxAmount += +item['domesticTaxAmount'];
        }
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: _round(originalTotalAmount,2) + '',
          domesticTotalAmount: _round(domesticTotalAmount,2) + '',
          originalTotalAmountWithoutTax: _round(originalTotalAmountWithoutTax,2) + '',
          originalTotalTaxAmount: _round(originalTotalTaxAmount,2) + '',
          domesticTotalAmountWithoutTax: _round(domesticTotalAmountWithoutTax,2) + '',
          domesticTotalTaxAmount: _round(domesticTotalTaxAmount,2) + '',
        };
      },
      // 计算明细表中的原币金额和本币金额反填到结算表中
      _computedDetailTableTotalAmount(tableData, isNew = false) {
        if (tableData && tableData.length) {
          let domesticAmount = 0;
          let originalAmount = 0;
          let originalAmountWithoutTax = 0;
          let originalTaxAmount = 0;
          let domesticAmountWithoutTax = 0;
          let domesticTaxAmount = 0;
          let settlementQuantityTotal = 0; // 结算数量
          for (const item of tableData) {
            originalAmount += +item['originalAmount'];
            domesticAmount += +item['domesticAmount'];
            settlementQuantityTotal += +item['settlementQuantity'];
            originalAmountWithoutTax += +item['originalAmountWithoutTax'];
            originalTaxAmount += +item['originalTaxAmount'];
            domesticAmountWithoutTax += +item['domesticAmountWithoutTax'];
            domesticTaxAmount += +item['domesticTaxAmount'];
          }
          let businessDocNoList = [...new Set(tableData.map((it) => it.businessDocNo))];
          let businessDocNo = businessDocNoList.length > 1 ? '' : businessDocNoList[0];
          const originalPriceList = tableData.map((item) => item.originalPrice);
          const originalPrice =
            [...new Set(originalPriceList)].length > 1 ? '' : originalPriceList[0];

          const unitList = tableData.map((item) => item.unit);
          const unit = [...new Set(unitList)].length > 1 ? '' : unitList[0]; // 单位编码
          const settlementQuantity =
            [...new Set(unitList)].length > 1 ? '' : settlementQuantityTotal.toFixed(4);
          const unitNameList = tableData.map((item) => item.unitName);
          const unitName = [...new Set(unitNameList)].length > 1 ? '' : unitNameList[0]; // 单位名称
          console.log(originalPrice, unit, settlementQuantity, '---->>');
          // 给第一个表格赋值
          this.currentDetailData = {
            domesticAmount: _round(domesticAmount,2) + '',
            originalAmount: _round(originalAmount,2) + '',
            originalPrice,
            settlementQuantity,
            additional: '',
            businessDocNo,
            unit,
            unitName,
            originalAmountWithoutTax: _round(originalAmountWithoutTax,2) + '',
            originalTaxAmount: _round(originalTaxAmount,2) + '',
            domesticAmountWithoutTax: _round(domesticAmountWithoutTax,2) + '',
            domesticTaxAmount: _round(domesticTaxAmount,2) + '',
            _XID: isNew ? null : this.currentSettleAccountRowData._XID, // 当前行
          };
        }
      },
      // 根据id来查下数据
      async _getDetailDataById(id) {
        if (!id) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(
          `${RECEIVABLES_TRADE.GET_RECEIVABLE_SETTLEMENT_DETAIL_BY_ID}/${id}`
        );
        console.log(data, 'data');
        if (data.code == 0) {
          this.loading.endLoading();
          this.detailData = data.data;
          // 单独抽取表单数据
          const {
            settlementCompanyNo,
            settlementCompanyName,
            settlementDepartmentNo,
            settlementDepartmentName,
            customerName,
            customerNo,
            orderCode,
            receivableSettlementNo,
            settlementDate,
            projectInitiationNo,
            projectName,
            contractNo,
            domesticTotalAmount,
            settlementType,
            currencyCode,
            currencyName,
            exchangeDate,
            exchangeRate,
            settlementStatus,
            settlementIssueStatus,
            invoiceAmount,
            collectedAmount,
            salesmanNo,
            salesmanName,
            weaveNo,
            weaveName,
            settlementCreateDate,
            originalTotalAmount,
            settlementBusinessType,
            receivableAccountPeriod,
            receiveStatus,
            printFlag,
            remark,
            signetType,
          } = data.data;
          this.baseFormData = {
            settlementCompanyNo,
            settlementCompanyName,
            settlementDepartmentNo,
            settlementDepartmentName,
            customerName,
            customerNo,
            orderCode,
            receivableSettlementNo,
            settlementDate,
            projectInitiationNo,
            projectName,
            contractNo,
            domesticTotalAmount: domesticTotalAmount ? domesticTotalAmount + '' : '0',
            settlementType,
            currencyCode,
            currencyName,
            exchangeDate,
            exchangeRate: exchangeRate ? exchangeRate + '' : '0',
            settlementStatus,
            settlementIssueStatus,
            invoiceAmount: invoiceAmount ? invoiceAmount + '' : '0',
            collectedAmount: collectedAmount ? collectedAmount + '' : '0',
            salesmanNo,
            salesmanName,
            weaveNo,
            weaveName,
            settlementCreateDate,
            originalTotalAmount: originalTotalAmount ? originalTotalAmount + '' : '0',
            settlementBusinessType,
            receivableAccountPeriod,
            receiveStatus,
            printFlag: printFlag === 0 ? false : true,
            signetType: signetType.split(','),
            remark,
          };
          this.statementStatus = settlementStatus; //结算单状态
          this.statementIssueStatus = settlementIssueStatus; //开票状态
          // 反填部门信息
          this._getDepartmentByCompanyCodeApi(settlementCompanyNo);
          this._getInvoiceTablelistData(this.$route.query?.receiveNo);
          this._getCollectTablelistData(this.$route.query?.receiveNo);
          //根据公司部门下的合同获取商品
          // this._getContractProduct(settlementCompanyNo, settlementDepartmentNo, contractNo);
        } else {
          this.$message.error('获取数据失败');
        }
      },
      async _getContractProduct(companyCode, departmentCode, contractNo) {
        const postData = { companyCode, departmentCode, contractNo, contractCategory: 'sales' };
        const { data } = await this.$axios.post(SALE_API.STATEMENT_CONTRACT_LIST_API, postData);
        if (data.code == 0) {
          let orderDetailList = data.data[0].orderDetailList;
          if (orderDetailList.length) {
            orderDetailList.map((item) => {
              if (item.contractMatterName && item.contractMatter) {
                this.productList.push({
                  label: item.contractMatterName,
                  value: item.contractMatter,
                });
              }
            });
          }
        }
      },
      async _getInvoiceTablelistData(receiveNo) {
        if (!receiveNo) return;
        const postData = { receivableSettlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_INVOICING_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.billingInfoData = data.data || [];
          // let invoiceAll = 0;
          // if (data.data.length > 0) {
          //   for (const item of data.data) {
          //     invoiceAll += +item['invoiceAmount'];
          //   }
          // }
          // // 赋值给表单
          // this.baseFormData = {
          //   ...this.baseFormData,
          //   invoiceAmount: invoiceAll + '',
          // };
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '开票信息');
      },
      async _getCollectTablelistData(receiveNo) {
        if (!receiveNo) return;
        const postData = { settlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_COLLECTION_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.payeeInfoData = data.data || [];
          // let collectAll = 0;
          // if (data.data.length > 0) {
          //   for (const item of data.data) {
          //     collectAll += +item['originReceiveMoneyAmount'];
          //   }
          // }
          // // 赋值给表单
          // this.baseFormData = {
          //   ...this.baseFormData,
          //   collectedAmount: collectAll + '',
          // };
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '收款信息');
      },
      //费用清单跳转过来创建结算单
      async _getBaseformData(ids) {
        if (ids.length < 1) return;
        this.loading.startLoading();
        const postData = { ids };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_BASEFORMDATA_BY_IDS,
          postData
        );
        console.log(data, '基本信息');
        if (data.code == 0) {
          this.loading.endLoading();
          // 单独抽取表单数据
          const {
            businessCompanyNo,
            businessCompanyName,
            businessDepartmentCode,
            businessDepartmentName,
            customerName,
            customerNo,
            orderCode,
            settlementNo,
            periodDateUntil,
            projectInitiationNo,
            projectName,
            contractNo,
            domesticAmount,
            currencyCode,
            currencyName,
            exchangeDate,
            exchangeRate,
            settlementStatus,
            // settlementIssueStatus,
            invoiceAmount,
            collectedAmount,
            originalAmount,
            accountPeriod,
            receiveStatus,
            // printFlag,
            remark,
          } = data.data[0];
          this.baseFormData = {
            settlementCompanyNo: businessCompanyNo,
            settlementCompanyName: businessCompanyName,
            settlementDepartmentNo: businessDepartmentCode,
            settlementDepartmentName: businessDepartmentName,
            customerName,
            customerNo,
            orderCode,
            receivableSettlementNo: settlementNo,
            settlementDate: periodDateUntil,
            projectInitiationNo,
            projectName,
            contractNo,
            domesticTotalAmount: domesticAmount ? domesticAmount + '' : '0',
            settlementType: '2',
            currencyCode,
            currencyName,
            exchangeDate,
            exchangeRate: exchangeRate ? exchangeRate + '' : 1,
            settlementStatus,
            settlementIssueStatus: '02',
            invoiceAmount: invoiceAmount ? invoiceAmount + '' : '0',
            collectedAmount: collectedAmount ? collectedAmount + '' : '0',
            salesmanNo: this.userInfo.personNo,
            salesmanName: this.userInfo.personName,
            settlementCreateDate: formatDate(new Date()),
            originalTotalAmount: originalAmount ? originalAmount + '' : '0',
            settlementBusinessType: '02',
            receivableAccountPeriod: accountPeriod,
            receiveStatus,
            printFlag: false,
            remark,
          };
          console.log(this.baseFormData, 'this.baseFormDatathis.baseFormData');
          // 反填部门信息
          this._getDepartmentByCompanyCodeApi(businessCompanyNo);
          this.assembleHandler(data.data);
          //根据公司部门下的合同获取商品
          // this._getContractProduct(businessCompanyNo, businessDepartmentCode, contractNo);
          console.log(data, '基本信息');
        }
      },
      //将行明细组装成行信息
      assembleHandler(tableData) {
        let originalTotalAmountWithoutTax = 0;
        let originalTotalTaxAmount = 0;
        let domesticTotalAmountWithoutTax = 0;
        let domesticTotalTaxAmount = 0;
        tableData.forEach((item) => {
          item.settlementQuantity = item.adjustStatementQuantity || item.statementQuantity;
          item.originalPrice = item.adjustOriginalPrice || item.originalPrice;
          item.exchangeRate = item.exchangeRate || 1;
          item.taxRate = item.taxRate || '0.00';
          item.businessDocNo = item.businessDocCode;
          item.originalAmount = item.adjustOriginalAmount || _round(item.originalAmount,2);
          item.domesticAmount = item.adjustDomesticAmount || _round(item.domesticAmount,2);
          item.originalAmountWithoutTax = _round((
            item.originalAmount /
            (1 + +(item.taxRate ? item.taxRate : 0))
          ),2);
          item.originalTaxAmount = (item.originalAmount - item.originalAmountWithoutTax).toFixed(2);
          item.domesticAmountWithoutTax = (
            item.domesticAmount /
            (1 + +(item.taxRate ? item.taxRate : 0))
          ).toFixed(2);
          item.domesticTaxAmount = (item.domesticAmount - item.domesticAmountWithoutTax).toFixed(2);
        });
        let domesticAmount = 0;
        let originalAmount = 0;
        for (const item of tableData) {
          originalAmount += +item['originalAmount'];
          domesticAmount += +item['domesticAmount'];
          originalTotalAmountWithoutTax += +item['originalAmountWithoutTax'];
          originalTotalTaxAmount += +item['originalTaxAmount'];
          domesticTotalAmountWithoutTax += +item['domesticAmountWithoutTax'];
          domesticTotalTaxAmount += +item['domesticTaxAmount'];
        }

        let dataMap = this.classificationHandler(tableData);
        console.log(dataMap, 'dataMapdataMapdataMap');
        let lines = [];
        for (const key in dataMap) {
          const currentItemList = dataMap[key].item; // 同一类供应商
          const currentUnit = [...new Set(currentItemList.map((it) => it.unit))];
          const currentUnitName = [...new Set(currentItemList.map((it) => it.unitName))];
          const unit = currentUnit.length > 1 ? '' : currentUnit[0]; // 单位
          const unitName = currentUnitName.length > 1 ? '' : currentUnitName[0]; // 单位名称
          const originalPriceList = [...new Set(currentItemList.map((it) => it.originalPrice))];
          let domesticAmount = 0;
          let originalAmount = 0;
          let settlementQuantityTotal = 0; // 数量
          for (const item of currentItemList) {
            originalAmount += +item['originalAmount'];
            domesticAmount += +item['domesticAmount'];
            settlementQuantityTotal += +item['settlementQuantity'];
          }
          let settlementQuantity = currentUnit.length > 1 ? '' : settlementQuantityTotal.toFixed(4);

          let businessDocNoList = [...new Set(currentItemList.map((it) => it.businessDocNo))];
          let businessDocNo = businessDocNoList.length > 1 ? '' : businessDocNoList[0];

          lines.push({
            settlementDesc: '',
            originalPrice: originalPriceList.length > 1 ? '' : originalPriceList[0],
            settlementQuantity,
            originalAmount: originalAmount.toFixed(2),
            currencyCode: currentItemList[0].currencyCode,
            currencyName: currentItemList[0].currencyName,
            contractNo: currentItemList[0].contractNo,
            exchangeRate: currentItemList[0].exchangeRate ? currentItemList[0].exchangeRate : 1,
            domesticAmount: domesticAmount.toFixed(2),
            additional: '',
            businessDocNo,
            unit,
            unitName,
            productType: currentItemList[0].productType,
            productTypeName: currentItemList[0].productTypeName,
            serviceType: currentItemList[0].serviceType,
            serviceTypeName: currentItemList[0].serviceTypeName,
            expenseType: currentItemList[0].expenseType,
            expenseTypeName: currentItemList[0].expenseTypeName,
            originalAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.originalAmountWithoutTax, 0)
              .toFixed(2),
            originalTaxAmount: currentItemList
              .reduce((pre, next) => pre + +next.originalTaxAmount, 0)
              .toFixed(2),
            domesticAmountWithoutTax: currentItemList
              .reduce((pre, next) => pre + +next.domesticAmountWithoutTax, 0)
              .toFixed(2),
            domesticTaxAmount: currentItemList
              .reduce((pre, next) => pre + +next.domesticTaxAmount, 0)
              .toFixed(2),
            remark: '',
            id: currentItemList[0].id,
            lineDetails: currentItemList,
          });
        }
        this.detailData = { lines };
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
          originalTotalAmount: originalAmount.toFixed(2) + '',
          domesticTotalAmount: domesticAmount.toFixed(2) + '',
          originalTotalAmountWithoutTax: originalTotalAmountWithoutTax.toFixed(2),
          originalTotalTaxAmount: originalTotalTaxAmount.toFixed(2),
          domesticTotalAmountWithoutTax: domesticTotalAmountWithoutTax.toFixed(2),
          domesticTotalTaxAmount: domesticTotalTaxAmount.toFixed(2),
        };
      },

      classificationHandler(arr) {
        let map = [
          {
            productType: arr[0].productType,
            serviceType: arr[0].serviceType,
            expenseType: arr[0].expenseType,
            item: [arr[0]],
          },
        ];
        for (let i = 1; i < arr.length; i++) {
          let bool = map.some((it) => {
            if (
              arr[i].productType == it.productType &&
              arr[i].serviceType == it.serviceType &&
              arr[i].expenseType == it.expenseType
            ) {
              it['item'].push(arr[i]);
            }
            return (
              arr[i].productType == it.productType &&
              arr[i].serviceType == it.serviceType &&
              arr[i].expenseType == it.expenseType
            );
          });
          if (!bool) {
            map.push({
              productType: arr[i].productType,
              serviceType: arr[i].serviceType,
              expenseType: arr[i].expenseType,
              item: [arr[i]],
            });
          }
        }
        for (const it of map) {
          console.log(it, 'of循环map');
        }
        for (const it in map) {
          console.log(map[it].item, 'in循环map');
        }
        console.log(map, '分类处理');
        return map;
      },
    },
    mounted() {
      this.currentStatus = this.$route.query?.status; // 当前状态
      if (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0) {
        let ids = this.$route.query?.id;
        if (ids && Array.isArray(ids) && ids.length) {
          this._getBaseformData(ids);
        } else {
          this._getBaseformData([ids]);
        }
      }
      if (['detail', 'edit'].includes(this.$route.query?.status)) {
        this._getDetailDataById(this.$route.query?.id);
        // this._getInvoiceTablelistData(this.$route.query?.receiveNo);
        // this._getCollectTablelistData(this.$route.query?.receiveNo);
      }
    },
    computed: {
      btnList() {
        const allBtnList = [
          {
            title: '保存',
            type: 'save',
          },
          {
            title: '编辑',
            type: 'edit',
          },
          {
            title: '提交审批',
            type: 'approval',
          },
          {
            title: '开票申请',
            type: 'billingApplication',
          },
          {
            title: '结算锁定',
            type: 'settlementLock',
          },
          {
            title: '调整',
            type: 'resize',
          },
          {
            title: '撤回',
            type: 'cancel',
          },
          {
            title: '关闭',
            type: 'close',
          },
          {
            title: '打印',
            type: 'print',
          },
        ];
        // statementStatus:01-保存,02-审批中,03-已驳回,04-已通过,05-已撤回,06-已锁定,07-已关闭
        // statementIssueStatus  01-已开票,02-未开票,03-部分开票
        // billingInfoData  是否关联开票申请单   当billingInfoData.length>0就关联了 否则未关联
        // if (['create'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save'].includes(item.type));
        // }
        // if (['edit'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save', 'approval'].includes(item.type));
        // }
        if (['detail'].includes(this.currentStatus)) {
          // if (['01', '03', '05'].includes(this.statementStatus)) {
          //   // 已经保存,已驳回,已撤回
          //   return allBtnList.filter((item) => ['edit'].includes(item.type));
          // } else
          if (['04'].includes(this.statementStatus)) {
            if (this.billingInfoData.length < 1) {
              return allBtnList.filter((item) =>
                ['billingApplication', 'settlementLock', 'cancel', 'print'].includes(item.type)
              );
            } else if (
              this.billingInfoData.length > 1 &&
              ['02', '03'].includes(this.statementIssueStatus)
            ) {
              return allBtnList.filter((item) =>
                ['billingApplication', 'print'].includes(item.type)
              );
            } else if (
              this.billingInfoData.length > 1 &&
              ['01'].includes(this.statementIssueStatus)
            ) {
              return allBtnList.filter((item) => ['close', 'print'].includes(item.type));
            } else {
              return [];
            }
          }
          //  else if (['06'].includes(this.statementStatus) && this.billingInfoData.length < 1) {
          //   return allBtnList.filter((item) => ['resize'].includes(item.type));
          // }
          else {
            return [];
          }
        } else {
          return [];
        }
        // return allBtnList;
      },
      // 是否隐藏开票和收款信息
      isHiddenInfo() {
        return ['edit', 'detail'].includes(this.currentStatus);
      },
    },
    components: {
      // BaseInfo,
      SettleAccountsRow,
      SettleAccountsInfo,
      BillingInfo,
      PayeeInfo,
      // FileTable,
      SiruiSearch,
      Print,
      printDemo,
      PrintDialog,
      CommonTransportation,
      PublickTransport,
      RailwayTransportation,
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
</style>
